import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import styles from "./PersonalDashbord.module.css";

import BtnBack from '../helper/btnBackMTO/BtnBack';
import GetHeader from '../helper/getHeader/GetHeader';
import Search from './search/Search';
import Table from './table/Table';
import DigitalPortrait from '../../digital_rating/DigitalPortrait';
import { Radar } from '../../digital_rating/radar/Radar';

import { getInfo, getPhoto } from '../../../actions/radar';
import { BACKEND_URL_PREFIX, MONTHS } from '../../../utils/const';

import back1 from '../../../assets/dashboard/background_1.png';

import {
    getYears,
    getSpecialty,
    schoolYear,
    getCathedra,
    getGroup,
    getPeriod,
    getSchema,
    getCalculation,
    getMinMax,
    getStudents,
    getUniversity,
    groupsForMTO,
    groupsForMTOByProf,
    trashReport,
    trashSchema,
    trashCafedra,
    trashGroup,
    trashPortrait,
    trashCalcAnswer,
    trashCalculation,
    getMilitaryProfs
} from '../../../actions/report';
import { store } from '../../App';
import { signOut } from '../../../actions/auth';
import { createNotification } from '../../notifications/notifications';

const PersonalDashbord = ({
    getGroup,
    groupsForMTO,
    groupsForMTOByProf,
    students_list,
    special,
    getCathedra,
    cathedra,
    years,
    groups,
    scy,
    getSchema,
    schema,
    getPeriod,
    period,
    getCalculation,
    ratingCalc,
    getMinMax,
    minMaxRating,
    loadingRadar,
    getPhoto,
    photo,
    getSpecialty,
    schoolYear,
    university,
    getUniversity,
    trashReport,
    trashSchema,
    trashCafedra,
    trashGroup,
    trashPortrait,
    trashCalcAnswer,
    trashCalculation,
    getMilitaryProfs,
    military_profs,
    ...props
}) => {
    const [filter, setFilter] = useState({
        f: '',
        k: '',
        g: '',
        y: '',
        s: '',
        p: '',
        mpid: ''
    });

    const dispatch = store.dispatch;
    const history = props?.history;

    const [mid, setMid] = useState(null);
    const [fullPeriod, setFullPeriod] = useState([]);
    const [selectedUni, setSelectedUni] = useState('');

    const id = useMemo(() => {
        const parts = window.location.pathname.split('/');
        return parts[parts.length - 2];
    }, []);

    useEffect(() => {
        const access = store.getState().auth.access_modes?.['Режимы']?.['Показатели деятельности вуза'];
        if (access !== 'Полный' && id === 'all') {
            dispatch(signOut(history));
        }
    }, [dispatch, history, id]);

    useEffect(() => {
        if (selectedUni?.name === 'Филиал (г. Пенза)') {
            setFilter({
                f: '23', k: '10', g: '226', y: '32', s: '1', p: '9', mpid: ''
            });
        }
        if (selectedUni?.name === 'Военно-космическая академия им. А.Ф. Можайского (г. Санкт-Петербург)') {
            setFilter({
                f: '39', k: '168', g: '612', y: '37', s: '2', p: '9', mpid: ''
            });
        }
    }, [selectedUni]);

    useEffect(() => {
        if (selectedUni) {
            getSpecialty(selectedUni.api_url);
            schoolYear(selectedUni.api_url);
            getMilitaryProfs(selectedUni.api_url);
        } else {
            setSelectedUni('all');
        }
    }, [selectedUni]);

    useEffect(() => {
        if (filter.f && selectedUni) {
            getCathedra(filter.f, selectedUni.api_url);
        }
    }, [filter.f, selectedUni]);

    useEffect(() => {
        if (filter.f && selectedUni) {
            groupsForMTOByProf(selectedUni.api_url, filter.y, filter.f, filter.mpid);
        }
    }, [selectedUni?.api_url, filter.y, filter.f, filter.mpid]);

    useEffect(() => {
        if (filter.y && selectedUni) {
            getSchema(filter.y, selectedUni.api_url);
            getPeriod(filter.y, selectedUni.api_url);
        }
    }, [filter.y, selectedUni]);

    const getFullPeriod = () => {
        const found = fullPeriod.find(el => el.trmid === filter.p);
        return found?.term_type_id ? `${found.term_end?.split('.')}_` : `${filter.p}`;
    };

    const users = useMemo(() => {
        if (!ratingCalc || !ratingCalc.length) return [];

        // Новая структура: [{ first_level_title, first_level_id, user_results: [...] }, ...]
        if (ratingCalc[0]?.first_level_id && ratingCalc[0]?.user_results) {
            const userMap = {};

            ratingCalc.forEach((category) => {
                const title = category.first_level_title;

                if (category.user_results) {
                    category.user_results.forEach((user) => {
                    if (!userMap[user.mid]) {
                        userMap[user.mid] = {
                        id: user.mid,
                        mid: user.mid,
                        firstname: user.firstname,
                        lastname: user.lastname,
                        patronymic: user.patronymic,
                        final_point: 0,
                        details: []
                        };
                    }

                    const points = parseFloat(user.last_level_points) || 0;
                    userMap[user.mid].details.push({
                        first_level_title: title,
                        last_level_points: points,
                        last_level_count: user.last_level_count
                    });
                    userMap[user.mid].final_point += points;
                    });
                }
            });


            return Object.values(userMap).map((user) => [user]);
        }

        // Старая структура
        const grouped = {};
        for (const line of ratingCalc) {
            if (grouped[line.mid]) grouped[line.mid].push(line);
            else grouped[line.mid] = [line];
        }
        return Object.values(grouped);
    }, [ratingCalc]);

    useEffect(() => {
        if (users.length && users[0][0]) {
            setMid(users[0][0].mid);
        }
    }, [users]);

    const handleFilter = (e, name) => {
        const newFilter = { ...filter };
        newFilter[name] = e;

        if (name === 'f') Object.assign(newFilter, { k: '', g: '' });
        if (name === 'k') Object.assign(newFilter, { g: '' });
        if (name === 'y') Object.assign(newFilter, { s: '', p: '' });
        if (name === 's') Object.assign(newFilter, { p: '' });

        setFilter(newFilter);
    };

    const handleGetInfo = () => {
        if (selectedUni && filter.g && filter.y && filter.p !== '' && scy && filter.s) {
            getCalculation('rating_calc_details', filter.s, filter.g, filter.y, getFullPeriod(), selectedUni.api_url);
            getMinMax(filter.y, getFullPeriod(), filter.s, 1, filter.g, scy, selectedUni.api_url);
        } else {
            createNotification('error', 'Заполните параметры');
        }

    };

    useEffect(() => {
        // if (period && period.length >= 2) {
        //     const newPeriod = [
        //         ...MONTHS.slice(0, 5).map((m) => ({ title: m.name, trmid: m.value })),
        //         period[0],
        //         ...MONTHS.slice(5).map((m) => ({ title: m.name, trmid: m.value })),
        //         period[1]
        //     ];
            setFullPeriod(MONTHS.map(m => ({ title: m.name, trmid: m.value })));
        // }
    }, []);

    useEffect(() => {
        if (selectedUni && mid) {
            getPhoto(selectedUni.api_url, mid);
        }
    }, [mid, users]);

    useEffect(() => {
        if (university?.length && id) {
            const [one, two] = id.split('_');
            if (two === undefined) {
                setSelectedUni(university[one]);
            } else if (one && two) {
                setSelectedUni(university[one]?.branches?.[two]);
            } else {
                setSelectedUni({ api_url: `${BACKEND_URL_PREFIX}/` });
            }
        }
    }, [university, id]);

    const ratingCalcSingle = useMemo(() => {
        if (!ratingCalc || !mid) return [];

        // Новая структура (категории + user_results)
        if (ratingCalc[0]?.first_level_id && ratingCalc[0]?.user_results) {
            return ratingCalc.map((category) => {
                const user = category.user_results?.find((u) => u.mid === mid);
                return {
                    id: category.first_level_id,
                    title: category.first_level_title,
                    alias: category.first_level_title,
                    points: user ? user.last_level_points : 0,
                    mid
                };
            });
        }

        // Старая структура
        return ratingCalc.filter((line) => line.mid === mid);
    }, [ratingCalc, mid]);

    return (
        <div className={styles.wrapper} style={{ backgroundImage: "url('dashboard/background_1.png')" }}>
            <img src={back1} className={styles.bg} alt="background" />

            <GetHeader title={<>ВОЕННО - ПРОФЕССИОНАЛЬНЫЙ ПОРТРЕТ ОБУЧАЮЩЕГОСЯ</>} pathLogo={selectedUni?.api_url} />

            <Search
                special={special}
                cathedra={cathedra}
                years={years}
                groups={groups}
                students_list={students_list}
                handleFilter={handleFilter}
                filter={filter}
                setFilter={setFilter}
                handleGetInfo={handleGetInfo}
                scy={scy}
                schema={schema}
                getPeriod={getPeriod}
                period={fullPeriod}
                uni={selectedUni}
                trashReport={trashReport}
                trashSchema={trashSchema}
                trashCafedra={trashCafedra}
                trashGroup={trashGroup}
                trashPortrait={trashPortrait}
                trashCalcAnswer={trashCalcAnswer}
                trashCalculation={trashCalculation}
                military_profs={military_profs}
            />

            <div className={styles.layoutInfo}>
                <div className={styles.wrapperBlocks}>
                    <div className={styles.wrapperReport1}>
                        <Table users={users} groups={groups} filter={filter} setMid={setMid} mid={mid} />
                    </div>
                    <div className={styles.wrapperDigital1}>
                        <DigitalPortrait
                            data={ratingCalcSingle}
                            schemaType=""
                            isRadial={false}
                            isCompare={false}
                            ratingCalc={ratingCalcSingle}
                            mid={mid}
                            minMaxRating={minMaxRating}
                            loadingRadar={loadingRadar}
                            width='550px'
                            height='300px'
                            wrapLineMargin='0 1rem'
                            compareMargin='1rem 0'
                        />
                    </div>
                </div>

                <div className={styles.wrapperBlocks}>
                    <div className={styles.wrapperReport2}>
                        <DigitalPortrait
                            data={ratingCalc}
                            schemaType={filter.s}
                            isRadial={false}
                            isCompare={true}
                            ratingCalc={ratingCalc}
                            mid={mid}
                            minMaxRating={minMaxRating}
                            loadingRadar={loadingRadar}
                            width='400px'
                            height='300px'
                            wrapLineMargin='0 1rem'
                            compareMargin='1rem 0'
                        />
                    </div>

                    <div className={styles.wrapperDigital2}>
                        {mid && (
                            <Radar
                                data={ratingCalc}
                                imageUrl={photo}
                                minMax={minMaxRating}
                                mid={mid}
                                imgW='80px'
                                imgH='80px'
                                imgTop='56%'
                                height="500"
                                width="500"
                            />
                        )}
                    </div>
                </div>
            </div>

            <BtnBack />
        </div>
    );
};

const mapStateToProps = (state) => ({
    students_list: state.report.students_list,
    years: state.report.years,
    university: state.report.university,
    special: state.report.special,
    scy: state.report.scy,
    cathedra: state.report.cathedra,
    groups: state.report.groups,
    period: state.report.period,
    schema: state.report.schema,
    ratingCalc: state.report.ratingCalc,
    info: state.radar.info,
    minMaxRating: state.report.minMaxRating,
    loadingRadar: state.report.loadingRadar,
    photo: state.radar.photo,
    military_profs: state.report.military_profs
});

export default connect(mapStateToProps, {
    getSpecialty,
    getCathedra,
    getStudents,
    getYears,
    schoolYear,
    getGroup,
    groupsForMTO,
    groupsForMTOByProf,
    getPeriod,
    getSchema,
    getCalculation,
    getInfo,
    getMinMax,
    getPhoto,
    getUniversity,
    trashReport,
    trashSchema,
    trashCafedra,
    trashGroup,
    trashPortrait,
    trashCalcAnswer,
    trashCalculation,
    getMilitaryProfs
})(PersonalDashbord);
